"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN = void 0;
exports.MIN = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        let minimum = null;
        for (const input of inputs) {
            // Array inputs
            if (Array.isArray(input)) {
                // eslint-disable-next-line no-restricted-syntax
                for (let rowIdx = 0; rowIdx < input.length; rowIdx += 1) {
                    const arrayElement = input[rowIdx];
                    if (typeof arrayElement !== 'number') {
                        return {
                            error: `All array elements for MIN must consist of numbers, but received [input:${arrayElement}] of [type:${typeof arrayElement}]`,
                        };
                    }
                    minimum =
                        minimum !== null ? Math.min(minimum, arrayElement) : arrayElement;
                }
            }
            else if (typeof input === 'number') {
                // Number inputs
                minimum = minimum !== null ? Math.min(minimum, input) : input;
            }
            else {
                return {
                    error: `Input values for MIN must be numbers or arrays of numbers, but received [input:${input}] of [type:${typeof input}]`,
                };
            }
        }
        if (minimum === null) {
            return {
                error: 'Input values for MIN must contain at least 1 number',
            };
        }
        return { error: null, result: minimum };
    },
};
//# sourceMappingURL=min.js.map